import { all, call, spawn } from 'redux-saga/effects';
import { sagas as i18nSaga } from '@altermaind/core/i18n';
import { aspectRootSaga } from '@/aspect/state';
import { billingRootSaga } from '@/billing/state';
import { coreSaga } from '@/core/state';
import { creditsSaga } from '@/credits/rootSaga';
import { departmentsRootSaga } from '@/departments/state';
import { invitationSaga } from '@/invitation/state';
import { loginSaga } from '@/login/state';
import { organizationSaga } from '@/organization/state';
import { paymentsRootSaga } from '@/payments/state';
import { peopleSaga } from '@/people/state';
import { profileSaga } from '@/profile/state';
import { reportsRootSaga } from '@/reports/state/rootSaga';
import { surveysRootSaga } from '@/surveys/state';
import { trainingContentsLikesRootSaga } from '@/training/contentsLikes/state';
import { trainingContentsRatingRootSaga } from '@/training/contentsRating/state';
import { trainingContentsOrchestratorRootSaga } from '@/training/hardSkills/state';
import { quizRootSaga } from '@/training/quiz/state';
import { softSkillsContentsRootSaga } from '@/training/softSkills/state';

export default function* rootSaga() {
  const sagas = [
    i18nSaga,
    loginSaga,
    coreSaga,
    organizationSaga,
    paymentsRootSaga,
    aspectRootSaga,
    billingRootSaga,
    peopleSaga,
    surveysRootSaga,
    departmentsRootSaga,
    creditsSaga,
    profileSaga,
    trainingContentsLikesRootSaga,
    quizRootSaga,
    trainingContentsRatingRootSaga,
    trainingContentsOrchestratorRootSaga,
    softSkillsContentsRootSaga,
    invitationSaga,
    reportsRootSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
            // no-dd-sa
          } catch {} // eslint-disable-line no-empty
        }
      }),
    ),
  );
}
